<template>
  <div class="kpi-header">
    <!-- Left Section -->
    <div class="header-left">
      <!-- <div class="header-icon-wrapper">
        <ChartColumn class="header-icon" :size="24" />
      </div> -->
      <div class="header-info">
        <h2 class="header-title">{{ boardSetup?.label || title }}</h2>
        <p class="header-subtitle">{{ boardSetup?.description || subtitle }} {{ getWaves }}</p>
      </div>
    </div>

    <!-- Right Section -->
    <div class="header-actions">

      <!-- Neue Komponente statt BFormSelect -->
      <SavedViewSelection v-if="boardSetup"
                          v-model="selectedView"
                          :board-setup="boardSetup"
                          :disabled="disabled"
                          :placeholder="$t('Webportal.ChangeView')" />

      <BButton class="options-btn d-flex align-items-center justify-content-center"
              :disabled="!canUserChangeView"
              size="sm"
              style="min-width: 2.5rem;"
              variant="outline-primary"
              @click="$emit('add-click')">
        <Settings2 :size="16" />
        <!-- <span>{{ resolvedAddButtonText }}</span> -->
      </BButton>
    </div>
  </div>
</template>

<script>
import { ChartColumn, Grid3x3, List, Settings, Settings2, Plus } from 'lucide-vue-next';
import SavedViewSelection from '@/componentsv3/SavedViewSelection.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'KpiHeader',

  components: {
    ChartColumn,
    Grid3x3,
    List,
    Settings,Settings2,
    Plus,
    SavedViewSelection
  },

  data() {
    return {
      viewMode: 'grid',
      selectedView: this.boardSetup,
    };
  },

  props: {
    addButtonText: { type: String, default: null },
    boardSetup: { type: Object, required: false, default: null},
    disabled: { type: Boolean, default: false },
    subtitle: { type: String, default: '' },
    title: { type: String, default: 'Meine KPI-Übersicht' },
    waveData: { type: Object, default: () => ({}) }
  },

  emits: ['view-changed', 'config-click', 'add-click'],

  computed: {
    ...mapGetters('auth', ['isMSMUser']),

    resolvedAddButtonText() {
      return this.addButtonText || this.$t('Webportal.Kpi.Add');
    },
    canUserChangeView() {
      // MSM User kann alles ändern
      // Nicht-MSM User kann nur nicht-generische Views/Boards ändern
      return !this.boardSetup.isGeneric || this.isMSMUser;
    },

    getWaves() {
      if (!this.waveData || this.waveData.length === 0 || !this.waveData.Waves) {
        return '';
      }
      if (this.boardSetup?.description || this.subtitle)
        return ' - ' + this.waveData.Waves.map(w => w.Name).join(' / ');
      return this.waveData.Waves.map(w => w.Name).join(' / ');
    }
  },
  watch: {
    boardSetup: {
      handler(newVal, oldVal) {
        this.selectedView = newVal;
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.kpi-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0;


  @media (max-width: 991px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon-wrapper {
  flex-shrink: 0;
}

.header-icon {
  color: var(--target-primary);
}

.header-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  // color: var(--target-primary);
  margin: 0;
}

.header-subtitle {
  font-size: 14px;
  color: var(--color-muted-foreground);
  margin: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 991px) {
    width: 100%;
    flex-wrap: wrap;
  }

  // Bootstrap button group styling
  :deep(.btn-group) {
    .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 8.5px 10px;

      // &.btn-primary {
      //   background: var(--target-primary);
      //   border-color: var(--target-primary);
      //   color: white;
      // }

      &.btn-outline-secondary {
        background: white;
        border-color: var(--color-border);
        color: var(--color-muted-foreground);

        &:hover {
          background: #f3f4f6;
          border-color: var(--color-border);
          color: #374151;
        }
      }
    }
  }
}

.action-btn {
  display: inline-flex;
  align-items: center;
  border: 2px solid white;
  background-color: #182836;
  gap: 0.25rem;
  transition: all 0.15s ease;
  white-space: nowrap;
  height: 2rem;
  &:hover {
     background-color: #182836;
     border: 2px solid gray;
     box-shadow: none;
  }
}

// Dark Mode
:root.dark,
[data-bs-theme="dark"] {

  .header-subtitle {
    color: var(--color-muted-foreground);
  }

  .action-btn-secondary {
    background: var(--color-card);
    color: var(--color-foreground);
    border-color: var(--color-border);

    &:hover {
      // background: var(--color-muted);
    }
  }
}
</style>
